<template>
  <div id="printm">
    <div class="common-page common-head mt20 printhide">
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
      <!-- <div class="common-page common-tool-bar">
        <el-date-picker
          v-model="params.time"
          @change="changetime"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <div class="btn align-center ml10" @click="searchSubmit">
          <i class="icon-tr-search"></i>查询
        </div>
        <div class="btn ml10 align-center" @click="resetSearch">重置</div>
      </div> -->
    </div>

    <div class="f-list flex">
      <div class="flex1 flex" style="flex-direction: column; align-item: center">
        <div id="tab2" v-if="this.c_num" class="tab1"></div>

        <div id="tab1" class="tab1"></div>
      </div>
    </div>

    <!-- <div class="center mt20 printhide" style="margin-bottom:20px">
             <el-button type="primary" v-print="'#printm'">打印报表</el-button>

    </div> -->
  </div>
</template>
<script>
import echarts from "echarts";
import { getTime } from "../../api/common.js";
export default {
  data() {
    return {
      power: 0,
      value1: [], // 时间查询
      c_num: this.$route.query.c_num || "",
      params: {
        time: "",
        starttime: "",
        page: 1,
        percentage_name: "",
        endtime: "",
        company_num: "",
      },
      getColor: "#005DAB",
      lostColor: "#DC000C",
      companyName: this.$route.query.name,
      // oneData:[],
    };
  },
  created() {
    setTimeout(() => {
      this.getList();
    }, 20);
  },
  mounted() {},
  //     watch:{
  //     cpNum(){
  //          this.getList()
  //     }
  // },
  methods: {
    changetime(val) {
      this.params.starttime = `${val[0]} 00:00:00`;
      this.params.endtime = `${val[1]} 23:59:59`;
    },
    searchSubmit() {},
    resetSearch() {
      this.params = {
        ...this.params,
        page: 1,
        starttime: "",
        endtime: "",
        time: "",
      };
    },
    // 三大项饼状图占比

    //  三大项横向统计图
    Br(params) {
      var newParamsName = ""; // 最终拼接成的字符串
      var paramsNameNumber = params.length; // 实际标签的个数
      var provideNumber = 4; // 每行能显示的字的个数
      var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整

      // 条件等同于rowNumber>1
      if (paramsNameNumber > provideNumber) {
        for (var p = 0; p < rowNumber; p++) {
          var tempStr = ""; // 表示每一次截取的字符串
          var start = p * provideNumber; // 开始截取的位置
          var end = start + provideNumber; // 结束截取的位置
          // 此处特殊处理最后一行的索引值
          if (p == rowNumber - 1) {
            // 最后一次不换行
            tempStr = params.substring(start, paramsNameNumber);
          } else {
            // 每一次拼接字符串并换行
            tempStr = params.substring(start, end) + "\n";
          }
          newParamsName += tempStr; // 最终拼成的字符串
        }
      } else {
        // 将旧标签的值赋给新标签
        newParamsName = params;
      }
      //将最终的字符串返回
      return newParamsName;
    },
    getUnitLines() {
      var _this = this;
      this.$post("/phpcontro/scoreAll").then((res) => {
        var valueArr = res.data;
        //   var seri = [] // 0 单位名称 1 安全得分 2 安全失分 3 建筑防火得分 4建筑防火失分 5 建筑设施得分 6 建筑设施失分

        var namearr = [];
        var safeArr = []; //安全得分
        var fireArr = []; // 建筑防火
        var sheshiArr = [];
        valueArr.map((item) => {
          namearr.push(item.label);
          safeArr.push(Number(item.anquanshifen));
          fireArr.push(Number(item.fanghuoshifen));
          sheshiArr.push(Number(item.sheshishifen));
        });
        this.makeLine({
          content: "tab1",
          config: {
            title: {
              left: "left",
              text: `各单位消防评估分类失分统计`,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
            },
            legend: {
              show: true,
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "value",
              },
            ],
            yAxis: [
              {
                type: "category",
                data: namearr,
                axisLabel: {
                  interval: 0,
                  rotate: 30,
                  formatter: function(params) {
                    return _this.Br(params);
                  },
                  textStyle: {
                    color: "#000",
                  },
                },
              },
            ],
            dataZoom: [
              // {
              //   start: 2,
              //   type: "inside",
              // },
              // {
              //   type: "slider",
              //   start: 2,
              // },
              {
                type: "slider", //滑动条
                show: true, //开启
                yAxisIndex: [0],
                left: "93%", //滑动条位置
                start: 20, //初始化时，滑动条宽度开始标度
                end: 50,
              }, //初始化时，滑动条宽度结束标度<br>
              {
                type: "inside", //内置滑动，随鼠标滚轮展示
                yAxisIndex: [0],
                start: 1,
              },
            ],
            series: [
              {
                name: "消防安全管理",
                type: "bar",
                stack: "消防安全管理得失分",
                data: safeArr,
                radius: "65%",
                label: {
                  show: true,
                  position: "right",
                  formatter: function(value) {
                    console.log(value.data);
                    if (!value.data) {
                      return "";
                    }
                  },
                },
                itemStyle: {},
              },
              {
                name: "建筑防火",
                type: "bar",
                stack: "建筑防火得失分",
                label: {
                  show: true,
                  position: "right",
                  formatter: function(value) {
                    console.log(value.data);
                    if (!value.data) {
                      return "";
                    }
                  },
                  // color:"black"
                },
                data: fireArr,
                itemStyle: {},
              },

              {
                name: "消防设施",
                type: "bar",
                stack: "消防设施得失分",
                label: {
                  show: true,
                  position: "right",
                  formatter: function(value) {
                    console.log(value.data);
                    if (!value.data) {
                      return "";
                    }
                  },
                  // color:"black"
                },
                data: sheshiArr,
                itemStyle: {},
              },
            ],
          },
        });
      });
    },
    //  个小项评分
    getDetails() {
      var _this = this;
      this.$post("/phpcontro/scoreOneDetails", {
        num: Number(this.c_num),
      }).then((res) => {
        var valueArr = res.data;
        //   var seri = [] // 0 单位名称 1 安全得分 2 安全失分 3 建筑防火得分 4建筑防火失分 5 建筑设施得分 6 建筑设施失分

        var namearr = [];
        var safeArr = []; //安全得分
        var fireArr = []; // 建筑防火
        var sheshiArr = [];
        valueArr.map((item) => {
          namearr.push(item.name);
          safeArr.push(Number(item.defen));
          fireArr.push(Number(item.shifen));
        });
        this.makeLine({
          content: "tab2",
          config: {
            title: {
              left: "left",
              text: `各大单位${this.$route.query.c_name}得失分统计`,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
            },
            legend: {
              show: true,
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "value",
              },
            ],
            yAxis: [
              {
                type: "category",
                data: namearr,
                axisLabel: {
                  interval: 0,
                  rotate: 30,
                  formatter: function(params) {
                    return _this.Br(params);
                  },
                  // formatter: function (value) {
                  //   console.log(value);
                  //   var str = value.split("");
                  //   return str.join("\n");
                  // },
                  textStyle: {
                    color: "#000",
                  },
                },
              },
            ],
            dataZoom: [
              // {
              //   start: 2,
              //   type: "inside",
              // },
              // {
              //   type: "slider",
              //   start: 2,
              // },
              {
                type: "slider", //滑动条
                show: true, //开启
                yAxisIndex: [0],
                left: "93%", //滑动条位置
                start: 10, //初始化时，滑动条宽度开始标度
                end: 50,
              }, //初始化时，滑动条宽度结束标度<br>
              {
                type: "inside", //内置滑动，随鼠标滚轮展示
                yAxisIndex: [0],
                start: 1,
              }, //初始化时，滑动条宽度开始标度<br>                        end: 50  //初始化时，滑动条宽度结束标度
            ],
            series: [
              {
                name: "得分",
                type: "bar",
                stack: "得分",
                data: safeArr,
                radius: "65%",
                label: {
                  show: true,
                  position: "right",
                  formatter: function(value) {
                    if (!value.data) {
                      return "";
                    }
                  },
                },
                itemStyle: {
                  normal: {
                    color: this.getColor,
                  },
                },
              },

              {
                name: "失分",
                type: "bar",
                stack: "失分",
                label: {
                  show: true,
                  position: "right",
                  formatter: function(value) {
                    console.log(value.data);
                    if (!value.data) {
                      return "";
                    }
                  },
                  // color:"black"
                },
                data: fireArr,
                itemStyle: {
                  normal: {
                    color: this.lostColor,
                  },
                },
              },
            ],
          },
        });
      });
    },

    getList() {
      this.getUnitLines();
      if (this.c_num) {
        this.getDetails();
      }
    },
    // searchSubmit() {
    //   // function changeArr(val) {
    //   //   var arr = val.split(" ");
    //   //   var n = arr[0].replace(/['年','月']/g, "-");
    //   //   n = n.replace(/日/g, "");
    //   //   return n;
    //   // }
    //   this.clear();

    //   // console.log(this.params)
    //   // return
    //   //  console.log(this.params)
    //   this.getList();
    // },

    clear() {},

    makeLine({ data, content, config }) {
      var option = {
        title: {
          text: "多单位失分对比统计图",
          // subtext: '测试'
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: true,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          data: ["单位甲", "单位乙", "单位丙", "单位丁", "单位戊", "单位己", "单位庚"],
        },

        series: [
          {
            name: "得分",
            type: "bar",
            stack: "得分",
            data: [32, 21, 20, 30, 33, 43, 6],
            label: {
              show: true,
              position: "right",
            },
          },
          {
            name: "失分",
            type: "bar",
            stack: "失分",
            data: [32, 21, 20, 30, 33, 43, 6],
            label: {
              show: true,
              position: "right",
            },
          },
        ],
      };
      if (config) {
        option = { ...option, ...config };
      }

      echarts.init(document.getElementById(content)).setOption(option);
    },
    //饼图
    makeChart({ data, content, config }) {
      // console.log(this.chartList)

      let option = {
        title: {
          text: "单位得分项饼图",
          subtext: "纯属虚构",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "left",
          show: true,
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: [
              { value: 28, name: "安全管理得分" },
              { value: 2, name: "安全管理失分" },
              { value: 30, name: "消防设施得分" },
              { value: 5, name: "消防设施失分" },
              { value: 25, name: "建筑防火得分" },
              { value: 10, name: "建筑防火失分" },
            ],
            itemStyle: {
              normal: {
                color: function(params) {
                  var colorList = ["#3300CC", "#000066", "#CC0000", "#990000", "#CCCC33", "#CC9933"];
                  return colorList[params.dataIndex];
                },
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      if (option) {
        option = { ...option, ...config };
      }
      echarts.init(document.getElementById(content)).setOption(option);
    },
  },
};
</script>
<style scoped lang="scss">
.tab1 {
  width: 80%;
  min-height: 400px;

  margin: 20px auto 20px auto;
}

#line {
  height: 250px;
  width: 100%;
}
#tab3 {
  height: 8000px;
}
@media print {
  #tab1,
  #tab2,
  #tab3,
  #tab4,
  #tab5,
  #tab6 {
    margin-top: 120px;
    width: 100%;
  }
  .printhide {
    display: none;
  }
}
</style>
